export function toMediaProxyPath(url?: string): string | undefined {
  if (!url) return undefined;
  try {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      const u = new URL(url);
      return u.pathname.startsWith('/uploads/') ? `/api/media${u.pathname}` : undefined;
    }
    return url.startsWith('/uploads/') ? `/api/media${url}` : undefined;
  } catch {
    return undefined;
  }
}
